class EmblaSlider extends HTMLElement {
  constructor() {
    super();
    this.autoplay = this.getAttribute('data-autoplay') === 'true';
    this.loop = this.getAttribute('data-loop') === 'true';
    this.autoplaySpeed =
      Number(this.getAttribute('data-autoplay-speed')) || 4000;
    const align = this.getAttribute('data-align') || 'start';
    const options = {
      loop: this.loop,
      speed: 10,
      align: align,
      containScroll: false,
    };
    const plugins = [];
    if (this.autoplay) {
      plugins.push(EmblaCarouselAutoplay({ delay: this.autoplaySpeed }));
    }
    this.embla = EmblaCarousel(
      this.querySelector('.embla__viewport'),
      options,
      plugins,
    );

    this.slides = this.querySelectorAll('.embla__slide');

    // Animate slides from left to right
    this.slides.forEach((slide, index) => {
      setTimeout(() => {
        slide.classList.add('is-loaded');
      }, index * 150);
    });

    const initialIndex = [...this.slides].findIndex(
      (slide) => slide.dataset.initial === 'true',
    );

    if (initialIndex !== -1) {
      // wait for layout to settle
      requestAnimationFrame(() => {
        this.embla.scrollTo(initialIndex, true);
      });
    }

    this.tabs = document.querySelectorAll('.routine-tabs .tab');

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const label = tab.dataset.productTag;

        const targetIndex = [...this.slides].findIndex(
          (slide) => slide.dataset.stepLabel === label,
        );

        if (targetIndex !== -1) {
          this.embla.scrollTo(targetIndex, true);
        }
      });
    });

    this.prevBtns = this.querySelectorAll('.embla__arrow--prev');
    this.nextBtns = this.querySelectorAll('.embla__arrow--next');
    this.prevBtns.forEach((btn) =>
      btn.addEventListener('click', () => this.embla.scrollPrev()),
    );
    this.nextBtns.forEach((btn) =>
      btn.addEventListener('click', () => this.embla.scrollNext()),
    );

    this.dots = this.querySelectorAll('.embla__dot');
    this.dots.forEach((dot, i) => {
      dot.addEventListener('click', () => this.embla.scrollTo(i));
    });

    this.embla.on('select', () => {
      this.selectDot();
      this.updateArrows();
      this.updateActiveTab();
    });

    this.selectDot();
    this.updateArrows();
  }

  updateActiveTab() {
    const selectedIndex = this.embla.selectedScrollSnap();
    const selectedSlide = this.slides[selectedIndex];
    if (!selectedSlide) return;

    const label = selectedSlide.dataset.stepLabel;

    this.tabs.forEach((tab) => {
      tab.classList.toggle(
        'active',
        tab.dataset.productTag === label,
      );
    });
  }

  updateArrows() {
    if (!this.loop) {
      this.prevBtns.forEach((btn) => {
        btn.disabled = !this.embla.canScrollPrev();
        btn.classList.toggle('is-disabled', !this.embla.canScrollPrev());
      });
      this.nextBtns.forEach((btn) => {
        btn.disabled = !this.embla.canScrollNext();
        btn.classList.toggle('is-disabled', !this.embla.canScrollNext());
      });
    }
  }

  selectDot() {
    const selectedIndex = this.embla.selectedScrollSnap();
    const slideCount = this.slides.length;

    this.dots.forEach((dot, i) => {
      dot.classList.toggle(
        'is-selected',
        i === this.embla.selectedScrollSnap(),
      );
    });

    this.slides.forEach((slide) => {
      slide.removeAttribute('data-selected');
    });

    // Mark the selected slide
    const selectedSlide = this.slides[selectedIndex];
    selectedSlide.setAttribute('data-selected', 'true');
  }
}

if (!customElements.get('embla-slider')) {
  customElements.define('embla-slider', EmblaSlider);
}